import React from "react";

import CreateComment from "./createComment";
import ResponseLink from "./responseLink";
import RatingStars from "./ratingStars";

function Comment(props) {
  function responseClick(e) {
    e.preventDefault();
    props.setParentId(props.comment.id);
  }

  const comment = props.comment;
  const dateCreated = new Date(comment.date_gmt);
  const commentId = `comment-${comment.id}`;

  // Extract rating - WP Recipe Maker stores as wprm_comment_rating
  const ratingValue = comment.wprm_comment_rating 
    ? parseInt(comment.wprm_comment_rating, 10)
    : 0;

  return (
    <li id={commentId} className="comment">
      <article className="comment-body">
        <header className="comment-header">
          <img
            className="comment-avatar"
            src={comment.author_avatar_urls[48]}
            srcSet={`${comment.author_avatar_urls[96]} 2x`}
            width="48"
            height="48"
            alt="Comment avatar"
          />
          <div className="comment-meta">
            <b>{comment.author_name}</b>
            <p>
              <time dateTime={comment.date_gmt}>
                {dateCreated.toLocaleString()}
              </time>
            </p>
            {ratingValue > 0 && (
              <div style={{ marginTop: "0.5rem" }}>
                <RatingStars ratingValue={ratingValue} isReadOnly={true} label={null} />
              </div>
            )}
          </div>
        </header>
        <div
          className="comment-content"
          dangerouslySetInnerHTML={{ __html: comment.content.rendered }}
        />
        {props.allowComments ? (
          <ResponseLink onClick={responseClick} commentId={commentId} />
        ) : null}
      </article>
      {props.answeredTo ? (
        <CreateComment
          allowComments={props.allowComments}
          pageId={props.pageId}
          parentId={comment.id}
          setParentId={props.setParentId}
          restUrl={props.restUrl}
          user={props.user}
        />
      ) : null}
    </li>
  );
}

export default Comment;